import { ChangeEvent } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  InputAdornment,
  TextField as MuiTextField,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { IconButton } from '@occc/ui-design-system';
import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

import {
  SELECT_TARGET_SECTION_TITLE,
  SELECT_TARGET_SECTION_SUBTITLE,
  TERMINAL_KIOSK_IDS_FIELD_LABEL,
} from '../touchpoint.constants';

type SelectTargetSectionProps = {
  displayValue: string;
  onOpenKioskDialog: () => void;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  title?: string;
  subtitle?: string;
  fieldLabel?: string;
  error?: string;
};

export const SelectTargetSection = ({
  displayValue,
  onOpenKioskDialog,
  onChange,
  title = SELECT_TARGET_SECTION_TITLE,
  subtitle = SELECT_TARGET_SECTION_SUBTITLE,
  fieldLabel = TERMINAL_KIOSK_IDS_FIELD_LABEL,
  error,
}: SelectTargetSectionProps) => {
  const { isEditable } = useCanEditFormFieldsContext();

  return (
    <Box mb={2}>
      <Card>
        <CardHeader
          title={
            <Typography variant='subtitle1' paragraph>
              {title}
            </Typography>
          }
        />
        <CardContent>
          <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
            {subtitle}
          </Typography>
          <MuiTextField
            name='kioskIds'
            label={fieldLabel}
            value={displayValue}
            onChange={onChange}
            fullWidth
            disabled={!isEditable}
            error={!!error}
            helperText={error}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    onClick={onOpenKioskDialog}
                    size='small'
                    edge='end'
                    disabled={!isEditable}
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </CardContent>
      </Card>
    </Box>
  );
};
